import React, { Component } from "react";
import Header from "../../components/header/header";

class Layout4 extends Component {
    render() {
        return (
            <>
                <Header />
                <div>
                    <div className="main">
                        {this.props.children}
                    </div>
                </div>
            </>
        );
    }
}

export default Layout4;
